<template>
  <section class="content">
      <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                  <label for="purchaseSalesDate">Sales Date</label>
                  <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
                  <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="returnNo" >Return No</label>
                <InputText id="returnNo"  v-model="returnNo" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="refno" >Reference No</label>
                <InputText id="refno" v-model="referenceNumber" />
              </div>
              <div class="p-field p-col-12 p-md-2">
               <label for="paymentType" >Vat Type</label>
                <select class="form-control" v-model="taxType">
                  <option selected disabled value="">Select VatType</option>
                  <option  v-for="(tax,ind) in taxTypeList" :key="ind">{{tax.name}}</option>
                </select>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-4">
                <label >Sale To</label>
                  <Dropdown
                    v-model="accountMaster"
                    :options="supplierCustomerCashList"
                    optionLabel="name"
                    placeholder="Select Account"
                    :showClear="true"
                  />
              </div>
                <div class="p-field p-col-12 p-md-4" v-if="ifCash">
                  <label>Vendor</label>
                  <InputText placeholder="Vendor Name" v-model="vendorName"/>
                </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="warehouse" >Store</label>
                <Dropdown
                 v-if="!setWarehouseData"
                  v-model="warehouse"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                />
                <Dropdown
                 v-if="setWarehouseData"
                  v-model="warehouse"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :disabled="true"
                />
              </div>

            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2" v-if="!ifNotCash">
                <div class="p-field p-col-12 p-md-2">
                  <label for="panNo">Cur. Bal: </label>
                  <b style="color:red" v-if="accountMaster.closingBalance>0">{{(accountMaster.closingBalance).toFixed(2) + 'Cr'}}</b>
                  <b style="color:green" v-else>{{(accountMaster.closingBalance*(-1)).toFixed(2) + 'Dr'}}</b>
                </div>
                <div class="p-field p-col-12 p-md-2" v-if="accountMaster.panNo!= ''">
                  <label for="panNo" >Pan No</label>
                  <b>{{accountMaster.panNo}}</b>
                </div>
                <div class="p-field p-col-12 p-md-2" v-if="accountMaster.contactName!=''">
                  <label for="address">Contact Name</label>
                  <b>{{accountMaster.address}}</b>
                </div>
            </div>


            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                  <label for="itm">Item<b style="color:red">*</b></label>
                <!-- <Dropdown
                  v-model="item"
                  :options="itemMasterListByItemType"
                  optionLabel="name"
                  class="dropDown"
                  placeholder="Select One"
                /> -->
                 <AutoComplete v-model="item" filterMatchMode='contains'
                 :suggestions="filteredItems" @complete="searchItem($event)"
                  field="name" ref="itm">
                   <template #item="slotProps">
                     <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
                   </template>
                 </AutoComplete>
              </div>

              <div class="p-field p-col-12 p-md-2">
                <label  for="qty">Sales Qty</label>
                <!-- <input type="text" class="form-control" id="qty" @keypress="isNumber(event)" v-model="quantity"/> -->
              <InputNumber  id="minmaxfraction" v-model="quantity"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-1">
                <label for="qty">Unit</label>
                <InputText v-model="item.unitName" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="rate">Rate</label>
              <InputNumber  id="minmaxfraction" v-model="rate"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="total">Total</label>
                <InputNumber disabled  id="minmaxfraction"  v-model="total"
                             :minFractionDigits="2" :maxFracionDigits="4" />
              </div>

              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button p-component addNewBtn btn-btm-0" id="act" @click.prevent="addItemToDTOList" :label="editDTO?'Update':'Add'"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button-raised p-button-danger" v-if="editDTO" id="act" @click.prevent="itemDTOreset" label="Cancel"/>
              </div>
            </div>
            <div style="display:none">{{totalAmount}}{{findRate}}</div>
              <div class="p-field p-col-12 p-md-2" v-if="item.closingStock >=0">
                <label for="avl">Cur. Qty: </label>
                <span> {{item.closingStock}}</span>
            </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div >
            <div class="scrollable">
              <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th scope="col">SN</th>
                    <th scope="col">Item Name</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Rate</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                 <tbody  v-for="(item,index) in inventoryInOutDetailList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{item.itemMaster.itemNameWithCode}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.rate}}</td>
                    <td>{{item.rate * item.quantity}} </td>
                    <td>
                      <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editItemFromDTO(item,index)"/>
                      <Button icon="pi pi-trash" class="p-button-raised p-button-danger" v-if="editDTO"
                        @click="removeItemFromDTO(item, index)" disabled/>
                      <Button class="p-button-raised p-button-danger" icon="pi pi-trash" v-else-if="!editDTO"
                        @click="removeItemFromDTO(item, index)" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
                <hr>
                <div class="p-fluid p-formgrid p-grid p-mt-2">
                    <div class="p-field p-col-12 p-md-2">
                      <b style="margin-left: 15em;">Total:</b>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <b style="margin-left: 16em;">{{totalQty}}</b>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                      <b style="margin-left: 38em;">{{subTotal}}</b>
                    </div>
                  </div>
                <hr>
           </div>
         </div>
         <div class="p-fluid p-formgrid p-grid p-mt-2">
             <div class="p-field p-col-12 p-md-4">
                 <label >Narration</label>
                 <Textarea rows="6" v-model="narration"/>
             </div>

            <div class="p-field p-col-12 p-md-4">
            <table style="border: 1px solid #c8c8c8;">
                <thead >
                <tr>
                  <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Subtotal </th>
                  <th></th>
                  <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{subTotal}}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Discount </th>
                    <InputText v-model="discountPer"/>
                  <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{discountAmt}}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Taxable </th>
                  <th></th>
                  <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{taxable}}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Non-taxable </th>
                  <th></th>
                  <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{nonTaxable}}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Tax </th>
                  <th>13%</th>
                  <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{tax}}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Total </th>
                  <th></th>
                  <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{totalBillAmount}}</td>
                </tr>
              </thead>
            </table>
          </div>
            <div class="p-field p-col-12 p-md-4">
              <label >Reason<b style="color:red">*</b></label>
              <Textarea rows="6" v-model="returnReason"/>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid ">
            <div class="p-field p-col-12 p-md-6"></div>
            <div class="p-field p-col-12 p-md-1">
              <Button :label="editing?'Update':'Save'" icon="pi pi-save" class="p-button-raised p-button-success"
                  @click="addSalesReturn"/>
            </div>
          <div class="p-field p-col-12 p-md-1" v-if="this.salesReturn === undefined">
            <Button label="Reset" icon="pi pi-refresh" class="p-button-raised p-button-warning"  @click="reset"/>
          </div>
          <div class="p-field p-col-12 p-md-1" v-if="salesReturn != undefined" >
            <Button label="Cancel" class="p-button-raised p-button-danger"  @click="goBack()"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-info" label="Print" icon="pi pi-print"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-secondary" label="Generate PDF" icon="pi pi-download"/>
          </div>
        </div>
      </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import InputMask from 'primevue/inputmask'

export default {
  name: 'salesReturn',
  props: ['salesReturn'],
  data() {
    return {
      name: '',
      warehouse: '',
      taxTypeList: [
        {name: 'Exclusive', code: 'Exclusive'},
        {name: 'Inclusive', code: 'Inclusive'},
        {name: 'Exempt', code: 'Exempt'}
      ],
      item: '',
      accountMaster: '',
      vendorName: '',
      quantity: 0,
      rate: 0,
      purchaseSalesDate: null,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      taxType: '',
      taxable: 0,
      tax: 0,
      nonTaxable: 0,
      vatPercentage: '',
      salesMessage: '',
      returnReason: '',
      id: null,
      returnNo: null,
      editing: false,
      editDTO: false,
      index: null,
      inventoryOutHeaderId: null,
      itemSelected: '',
      loading: false,
      totalQty: '',
      total: 0,
      filteredItems: null,
      discountPer: 0,
      discountAmt: 0,
      referenceNumber: 0,
      englishDateEnabled: true,
      narration: '',
      setWarehouseData: false
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierCustomerCashList() {
      return this.$store.state.accountMaster.supplierCustomerCashList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    },
    // returnNo() {
    //   return this.$store.state.purchase.maxSalesReturnNumber
    // },
    // narration() {
    //   if (this.salesReturn === undefined) {
    //     return this.salesMessage + ' ' + this.returnNo
    //   } else {
    //     return this.salesMessage
    //   }
    // },
    ifCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster.name === 'cash') {
        return true
      }
    },
    ifNotCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster === '') {
        return true
      }
    },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate).toFixed(2)
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt
        return totalAmt
      }
    },
    findRate() {
      if (isNaN(this.rate)) {
        this.rate = 0
      }
      if (isNaN(this.total)) {
        this.total = 0
      }
      if (isNaN(this.quantity)) {
        this.quantity = 0
      }
      if (parseFloat(this.rate) > 0) {
        this.foundRateOnItem = true
      }
      this.rate = (parseFloat(this.rate))
      this.total = (parseFloat(this.total))
      this.quantity = (parseFloat(this.quantity))
      // if (this.foundRateOnItem) {
      // if (this.rate === 0) {
      let rates = 0
      if (this.total > 0 && this.quantity > 0) {
        rates = parseFloat(this.total) / parseFloat(this.quantity)
        this.rate = rates.toFixed(2)
      }
      if (isNaN(rates)) {
        rates = 0
      }
      if (isNaN(this.total)) {
        this.total = 0
      }
      return rates
    },
    subTotal() {
      let subTotal = 0
      let discountPerItem = 0
      let totalDiscountPerItem = 0
      this.taxable = 0
      this.tax = 0
      this.discountAmt = 0
      this.nonTaxable = 0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
        if (this.discountPer > 0) {
          this.discountAmt = (parseFloat(subTotal) * this.discountPer / 100).toFixed(4)
          discountPerItem = parseFloat(this.discountAmt) / parseFloat(this.totalQty)
        }
        switch (this.taxType) {
          case 'Exclusive':
            if (this.itemSelected.vatAble) {
              this.tax = 0
              totalDiscountPerItem = this.totalQty * discountPerItem
              this.taxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
              this.tax += parseFloat(this.taxable * 0.13)
            } else {
              totalDiscountPerItem = this.totalQty * discountPerItem
              this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
            }
            break
          case 'Inclusive':
            if (this.itemSelected.vatAble) {
              let amtWithoutVat = ((subTotal * 100) / (100 + 13)).toFixed(2)
              this.taxable += parseFloat(amtWithoutVat)
              this.tax += (parseFloat(subTotal) - parseFloat(amtWithoutVat)).toFixed(2)
            } else {
              this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
            }
            break
          case 'Exempt':
            this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
            break
        }
      }
      return subTotal
    },
    totalBillAmount () {
      let totalBillAmount = 0
      totalBillAmount = parseFloat(this.taxable) + parseFloat(this.tax) + parseFloat(this.nonTaxable)
      return totalBillAmount
    }
  },
  mounted() {
    this.warehouseList()
    this.supplierCustomerList()
    this.maxSalesReturnNo()
    this.itemMasterListByItemTypes()
    this.setWarehouse()
    if (this.salesReturn !== undefined) {
      this.editSalesReturn()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesReturn === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierCustomerAndCashList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemTypeSales')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouse = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouse = this.warehouseLists[0]
      }
    },
    async maxSalesReturnNo() {
      let response = await this.$store.dispatch('maxSalesReturnNumber')
      if (this.salesReturn === undefined) {
        this.returnNo = response.data.data
        this.salesMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.returnNo = this.salesReturn.returnNo
        this.salesMessage = this.salesReturn.remarks
      }
    },
    addItemToDTOList() {
      let item = {
        itemId: this.item.id,
        itemMaster: this.item,
        quantity: this.quantity,
        rate: this.rate,
        id: this.id
      }
      if (this.taxType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select sales type!', life: 10000})
        return
      }
      if (this.warehouse === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.accountMaster === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select sale to!', life: 10000})
        return
      }
      if (this.item.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.item === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      }
      if (!this.editDTO) {
        this.inventoryInOutDetailList.push({...item})
      } else {
        this.inventoryInOutDetailList.splice(this.index, 1, {...item})
      }
      this.itemDTOreset()
      this.focusInput()
    },
    editItemFromDTO(data, index) {
      this.itemDTOreset()
      this.editDTO = true
      this.item = data.itemMaster
      this.rate = data.rate
      this.quantity = data.quantity
      this.total = (parseFloat(data.rate) * parseFloat(data.quantity)).toFixed(2)
      this.index = index
      if (data.id !== undefined) {
        this.id = data.id
      }
    },
    async addSalesReturn() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select date!', life: 10000})
        return
      }
      let response = ''
      let salesReturn = {
        returnNo: this.returnNo,
        warehouseId: this.warehouse.id,
        accountMasterId: this.accountMaster.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        referenceNumber: this.referenceNumber,
        fiscalYearId: this.$store.state.fyId,
        remarks: this.narration,
        discountPercentage: this.discountPer,
        discount: this.discountAmt,
        billToName: this.vendorName,
        totalBillAmount: this.totalBillAmount,
        returnReason: this.returnReason,
        taxType: this.taxType,
        inventoryOutHeaderId: this.inventoryOutHeaderId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList
      }
      if (salesReturn.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      }
      if (this.returnReason === '') {
        this.message = 'Return reason cannot be empty.'
        this.$toast.add({severity: 'error', summary: '', detail: 'Return reason cannot be empty!', life: 10000})
        return
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('addSalesReturn', salesReturn)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateSalesReturn', salesReturn)
        this.loading = false
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        await this.maxSalesReturnNo()
        this.reset()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        return
      }
    },
    editSalesReturn() {
      this.editing = true
      this.inventoryInOutDetailList = this.salesReturn.inventoryInOutDetailList
      this.warehouse = this.salesReturn.warehouse
      this.discountPer = this.salesReturn.discountPercentage
      this.discountAmt = this.salesReturn.discount
      this.accountMaster = this.salesReturn.accountMaster
      this.taxType = this.salesReturn.taxType
      this.referenceNumber = this.salesReturn.referenceNumber
      this.returnReason = this.salesReturn.returnReason
      this.inventoryOutHeaderId = this.salesReturn.id
      this.narration = this.salesReturn.remarks
      this.salesMessage = this.salesReturn.remarks
      this.returnNo = this.salesReturn.returnNo
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.salesReturn.purchaseSalesDateNepali
      } else {
        this.purchaseSalesDate = this.salesReturn.purchaseSalesDate
      }
    },
    async removeItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
      this.totalBillAmount = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
    },
    itemDTOreset() {
      this.item = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.id = null
      this.editDTO = false
    },
    reset() {
      this.itemDTOreset()
      this.warehouse = ''
      this.accountMaster = ''
      this.referenceNumber = ''
      this.returnReason = ''
      this.taxType = ''
      this.discountPer = 0
      this.discountAmt = 0
      this.inventoryInOutDetailList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.salesReturn === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
      }
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
          })
        }
      }, 250)
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      // this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.salesReturn.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    InputMask,
    InputText,
    Button,
    Textarea
  }
}
</script>

<style scoped  src="@../../../static/css/purchase.css" >

</style>



// WEBPACK FOOTER //
// salesreturn.vue?02afcece